export const DATE_MASK = '00/00/0000'

export const CPF_MASK = '000.000.000-00'

export const CNPJ_MASK = '00.000.000/0000-00'

export const PHONE_MASK = [
  { mask: '(00) 0000-0000' },
  { mask: '(00) 00000-0000' }
]
